import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from "./store";
import './assets/base.css'
import 'lib-flexible/flexible'
import axios from './require/axios'
// vant
import {
  Swipe,
  SwipeItem,
  Loading,
  PullRefresh,
  List,
  Cell,
  Search,
  Skeleton,
  Dialog,
  Empty 
} from 'vant';
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Loading);
Vue.use(PullRefresh);
Vue.use(List);
Vue.use(Cell);
Vue.use(Search);
Vue.use(Skeleton);
Vue.use(Dialog);
Vue.use(Empty);
Vue.config.productionTip = false

Vue.prototype.$axios = axios
new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')